import React from 'react';
import { connect } from 'react-redux';
import Tab from './Tab';
import { setActiveTab } from '@actions/individualPortal/dashboard/dashboardActionCreators';
import { useLocalStorage } from '@hooks/useLocalStorage';
import { LOCAL_STORAGE } from '@constants/individualPortal/dashboard/dashboardModelTypes';
import styled from 'styled-components';
import { KEYBOARD_KEYS_CODE_NAME } from '@constants/common/shortcutKeys';

const StyledTabsWrapper = styled.div`
    padding: 0px 5px;

    .usa-list.gi-tabs {
        margin-top: unset; /* This is to unset the default margin-top property already defined in gi-tabs class*/
        margin-bottom: 6px;
    }

    .gi-tabs__item {
        flex: 1;
    }
`;

const Tabs = (props) => {
    const { dashboardModels, activeTab, setActiveTab } = props;
    const { setItem } = useLocalStorage();
    const onClickHandler = (idx, appYear) => {
        setItem(LOCAL_STORAGE.ACTIVE_TAB_INDEX, idx);
        setActiveTab(idx);

        // support old jsp pages
        const coverageYearHiddenInput = document.getElementById('coverageYear');
        if (coverageYearHiddenInput) {
            coverageYearHiddenInput.value = appYear;
        }
    };

    const onKeyDown = (e) => {
        const last = dashboardModels.length - 1;
        let next;
        if (e.key === KEYBOARD_KEYS_CODE_NAME.ARROW_RIGHT) next = activeTab === last ? 0 : activeTab + 1;
        else if (e.key === KEYBOARD_KEYS_CODE_NAME.ARROW_LEFT) next = activeTab === 0 ? last : activeTab - 1;
        else if (e.key === KEYBOARD_KEYS_CODE_NAME.HOME) next = 0;
        else if (e.key === KEYBOARD_KEYS_CODE_NAME.END) next = last;
        else return;
        e.preventDefault();
        onClickHandler(next, dashboardModels[next].applicationYear);
        document.getElementById(`tab-${next}`)?.focus();
    };

    const tabsList = dashboardModels.map((tab, idx) => (
        <Tab key={tab.applicationYear}
            onTabSelectHandler={() => onClickHandler(idx, tab.applicationYear)}
            onKeyDown={onKeyDown}
            tabData={tab}
            idx={idx}
            isActive={activeTab === idx}
            className="individual-portal-tab"
        />
    ));

    return (
        <StyledTabsWrapper>
            <div role="tablist" className="usa-list usa-list--unstyled grid-row gi-tabs mb-5">
                {tabsList}
            </div>
        </StyledTabsWrapper>
    );
};
const mapStateToProps = state => ({
    dashboardModels: state.individualPortal.dashboard.dashboardModels,
    activeTab: state.individualPortal.dashboard.activeTab
});

export default connect(mapStateToProps, { setActiveTab })(Tabs);
